import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Radius, Spacing, Typography } from 'chatie-design-system';

import Button from '@components/common/Button';
import RoundAvatar from '@components/common/RoundAvatar';

import { IEFinderObject } from '@model';

export type ChatRoomInfo = {
  characterName: string;
  image?: IEFinderObject<'image'>;
  lastMessage?: string;
  lastMessageDate?: string;
  id: number;
  type?: string;
};

const chatRoomCSS = css`
  display: flex;
  padding: ${Spacing.small}px ${Spacing.small}px ${Spacing.small}px
    ${Spacing.medium}px;
`;

const chatRoomHeaderCSS = (theme: Theme) =>
  css`
    display: flex;
    flex-direction: row;
    margin-left: ${Spacing.medium}px;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    h5 {
      display: flex;
      color: ${theme.var.black};
    }

    p {
      ${Typography.body12};
      color: ${theme.var.gray500};
      line-height: 135%;
      margin-top: ${Spacing.xxsmall}px;
    }
  `;

const storySelecButtonCSS = css`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  ${Typography.body12};
  padding: ${Spacing.xsmall}px ${Spacing.xsmall}px;
  width: 62px;
  height: 28px;
  border-radius: ${Radius.small}px;

  p {
    ${Typography.body12};
  }
`;

type EmptyChatRoomProps = {
  data: ChatRoomInfo;
  buttonText?: string;
  onClickAvatar?: (characterId: number) => void;
  onClickEnter?: (chatRoomInfo: ChatRoomInfo) => void;
};

const EmptyChatRoom = ({
  data,
  onClickAvatar,
  onClickEnter,
  buttonText = '입장하기',
}: EmptyChatRoomProps) => {
  const { t } = useTranslation();

  return (
    <article css={chatRoomCSS}>
      <div onClick={onClickAvatar ? () => onClickAvatar(data.id) : undefined}>
        <RoundAvatar size={44} picture={data?.image} />
      </div>
      <div
        css={chatRoomHeaderCSS}
        onClick={onClickEnter ? () => onClickEnter(data) : undefined}
      >
        <div>
          <h5>
            {t('{{characterName}}', {
              characterName: data.characterName,
            })}
          </h5>
          <p>
            {t('{{lastMessage}}', {
              lastMessage: data.lastMessage,
            })}
          </p>
        </div>
        <Button text={t(buttonText)} css={storySelecButtonCSS} />
      </div>
    </article>
  );
};

export default EmptyChatRoom;
